// extracted by mini-css-extract-plugin
export var dropdown = "_sr-0";
export var imageWrapper = "_sr-3";
export var itemNameContainer = "_sr-1";
export var productImage = "_sr-2";
export var spinnerWrapper = "_sr-4";